/* @jsx glam */
import glam from "glam";
import React from "react";

const FilmStrip = props => {
    const gutter = 2;

    return (
        <div
            css={{
                // borderBottom: `1px solid #EBECF0`,
                // borderTop: `1px solid #EBECF0`,
                marginLeft: -gutter,
                marginRight: -gutter,
                overflowX: "auto",
                paddingBottom: 10,
                paddingTop: 10,
                WebkitOverflowScrolling: "touch",
                whiteSpace: "nowrap"
            }}
            {...props}
        />
    );
};

export default FilmStrip;
